module.exports = __webpack_public_path__ + "media/brands/schmitz-b009b38b.png";